var _defs, _polyline, _polyline2, _polyline3, _polyline4, _polyline5, _polyline6, _polyline7, _polyline8, _line, _polyline9, _polyline10, _polyline11, _polyline12, _polyline13, _polyline14, _polyline15, _polyline16, _polyline17, _polyline18, _polyline19, _polyline20, _polyline21, _polyline22, _polyline23, _polyline24, _polyline25, _polyline26, _line2, _polyline27, _polyline28, _polyline29, _polyline30, _polyline31, _polyline32, _polyline33, _polyline34, _polyline35, _polyline36, _polyline37, _polyline38, _polyline39, _polyline40, _polyline41, _polyline42, _polyline43, _polyline44, _polyline45, _polyline46, _polyline47, _polyline48, _polyline49, _polyline50, _polyline51, _polyline52, _polyline53, _polyline54, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _polyline55, _circle114, _circle115;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1612 712",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b,.c{stroke:#000;stroke-miterlimit:10;stroke-width:3px;}.c{fill:none;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "540.5 626.5 579.5 665.5 654.5 665.5 682.5 695.5"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "620.5 620.5 773.5 620.5 806.5 581.5"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "831.5 607.5 850.5 590.5 1083.5 590.5"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "770.4 673.5 839.2 673.5 878.5 634.5 959.5 634.5"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "969.5 701.5 1006.7 701.5 1059.8 649.5 1076.5 649.5"
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "528.5 695.5 457.9 695.5 425 658 425 438.8"
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "378.7 566.5 95.4 566.5 57.8 599 57.5 675.5"
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "130.5 628.5 157.5 604.5 333.5 604.5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 161.2,
    y1: 679.5,
    x2: 102.5,
    y2: 679.5
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "392.5 456.1 350.5 500.5 204.5 500.5 177.5 526.5 85.5 526.5"
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "109.5 482.5 155.8 482.5 186.3 448.2"
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "255.5 448.5 329.5 448.2 392.5 387.2 392.5 298.5"
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "206.8 404.5 149.5 404.5 119.8 435.5 21.5 435.5"
  })), _polyline13 || (_polyline13 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "99.5 404.5 99.5 348.1 130.8 317.5 265.4 317.5 273.5 328.5"
  })), _polyline14 || (_polyline14 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "284.5 290.5 259.5 268.5 47.8 268.5"
  })), _polyline15 || (_polyline15 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "47.5 192.5 75.9 161.2 142.9 161.5 186.3 119.5 232 119.5"
  })), _polyline16 || (_polyline16 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "168.5 95.5 202.8 95.5 232 66.3 260.5 66.5 266.9 79.4"
  })), _polyline17 || (_polyline17 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "287.2 36.6 337.5 84.5 470.5 84.5"
  })), _polyline18 || (_polyline18 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "409.5 35.5 501.7 35.5 547.1 79.4 634.8 79.4 655.5 63.5"
  })), _polyline19 || (_polyline19 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "612.5 29.5 636.3 11 758.4 11"
  })), _polyline20 || (_polyline20 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "789.5 49.5 835.1 49.5 869.5 11 937.5 11.5"
  })), _polyline21 || (_polyline21 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "904 66.3 982.5 66.3 1008.5 37.5"
  })), _polyline22 || (_polyline22 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "938.5 108.5 868.7 108.6 841.4 79.4 700.5 79.5"
  })), _polyline23 || (_polyline23 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "733.5 115.5 742.5 105.5 830.5 105.5"
  })), _polyline24 || (_polyline24 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "747.5 168.5 776.7 138.3 808.5 138.3 813.5 145.5"
  })), _polyline25 || (_polyline25 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "1072.5 52.5 1093.9 82 1094.9 128.9 1115.5 146.5 1162.5 146.5"
  })), _polyline26 || (_polyline26 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "1137.5 103.5 1356.2 104 1391.6 132.5 1485.5 132.7"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 1424.3,
    y1: 79.5,
    x2: 1355.4,
    y2: 79.5
  })), _polyline27 || (_polyline27 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "1323.5 230.7 1353.5 207.5 1552 207.5 1600.5 260.5 1600.5 325.5"
  })), _polyline28 || (_polyline28 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "1569.5 346.5 1481.5 346.5 1467.5 330.5"
  })), _polyline29 || (_polyline29 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "1428.5 310.5 1429.5 355 1459.5 383.5 1542.5 384.5"
  })), _polyline30 || (_polyline30 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "1508.5 472.5 1483.1 495.3 1404.8 495.3"
  })), _polyline31 || (_polyline31 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "1518.5 520.5 1323.5 520.5 1296 495.3"
  })), _polyline32 || (_polyline32 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "1249.5 433.5 1249.9 560.9 1276.5 590.5 1359.5 590.5"
  })), _polyline33 || (_polyline33 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "1570.1 590.5 1411.1 590.5 1373.5 626.7 1282.5 626.5"
  })), _polyline34 || (_polyline34 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "750.5 575.5 515.2 575.5 471.5 534.3 471.5 424.5"
  })), _polyline35 || (_polyline35 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "1214 425.2 1214 533.5 1188.5 562.5 963.5 562.5"
  })), _polyline36 || (_polyline36 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "176.5 177.5 266.9 177.5 321.5 119.5 637.9 119.5 675.5 146.5 675.5 213.5 653.5 234.5"
  })), _polyline37 || (_polyline37 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "222.5 212.5 294.1 213.5 321.5 180.6 373.7 180.6"
  })), _polyline38 || (_polyline38 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "425.5 186.5 556.5 186.5 583.5 160.5"
  })), _polyline39 || (_polyline39 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "382.5 213.5 346.8 213.5 321.5 230.7"
  })), _polyline40 || (_polyline40 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "344.5 299.5 344.5 376.5 322.5 396.5 274.5 396.5"
  })), _polyline41 || (_polyline41 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "200.5 360.5 195.7 354.3 162.5 354.3"
  })), _polyline42 || (_polyline42 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "811.6 241.6 852.3 207.5 1020.5 207.5 1054.5 168.5 1054.5 108.5"
  })), _polyline43 || (_polyline43 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "1027.5 131.5 1027.5 151.5 1008.5 171.5 846.5 171.5 823.5 196.5"
  })), _polyline44 || (_polyline44 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "878.5 138.5 982.5 138.3 999.5 128.9"
  })), _polyline45 || (_polyline45 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "1249.9 368.5 1249.9 304.5 1238.5 293.5"
  })), _polyline46 || (_polyline46 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "1296 286.5 1329.7 286.5 1359.5 249.5 1480.5 249.5"
  })), _polyline47 || (_polyline47 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "1413.5 271.5 1393.3 271.5 1365.7 296.5 1365.7 368.5"
  })), _polyline48 || (_polyline48 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "1296 368.5 1336.8 368.5 1378.4 412.5 1408.5 412.5"
  })), _polyline49 || (_polyline49 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "1304.5 456.5 1450.2 456.1 1480.5 420.5 1560.5 420.5"
  })), _polyline50 || (_polyline50 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "1081.5 160 1124.1 207.5 1292.5 205.5 1311.5 186.5"
  })), _polyline51 || (_polyline51 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "1181.5 179.5 1218.5 146.5 1262.4 146.5"
  })), _polyline52 || (_polyline52 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "1296 146.5 1350.1 146.5 1375.5 171.5 1487.5 171.5"
  })), _polyline53 || (_polyline53 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "1213.8 647.5 1126.1 647.5 1092.8 618 1052.1 618 1044.5 626.5"
  })), _polyline54 || (_polyline54 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "423.5 344.5 423.5 271.5 473 222.1 593.3 222.1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 376,
    cy: 566,
    r: 9.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 334,
    cy: 604,
    r: 9.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 161,
    cy: 679,
    r: 9.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 393,
    cy: 456,
    r: 9.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 186,
    cy: 448,
    r: 9.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 207,
    cy: 405,
    r: 9.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 99,
    cy: 405,
    r: 9.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 50,
    cy: 268,
    r: 9.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 176,
    cy: 178,
    r: 9.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 272,
    cy: 90,
    r: 9.5
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 232,
    cy: 123,
    r: 9.5
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 345,
    cy: 303,
    r: 9.5
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 323,
    cy: 231,
    r: 9.5
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 374,
    cy: 178,
    r: 9.5
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 426,
    cy: 186,
    r: 9.5
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 594,
    cy: 222,
    r: 9.5
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 281,
    cy: 32,
    r: 9.5
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 410,
    cy: 34,
    r: 9.5
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 425,
    cy: 438,
    r: 9.5
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1219,
    cy: 648,
    r: 9.5
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 969,
    cy: 701,
    r: 9.5
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 770,
    cy: 677,
    r: 9.5
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 831,
    cy: 607,
    r: 9.5
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 806,
    cy: 580,
    r: 9.5
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 749,
    cy: 170,
    r: 9.5
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 830,
    cy: 105,
    r: 9.5
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 763,
    cy: 13,
    r: 9.5
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 792,
    cy: 49,
    r: 9.5
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 904,
    cy: 66,
    r: 9.5
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1000,
    cy: 129,
    r: 9.5
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1028,
    cy: 131,
    r: 9.5
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1067,
    cy: 45,
    r: 9.5
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 682,
    cy: 695,
    r: 9.5
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 748,
    cy: 573,
    r: 9.5
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1250,
    cy: 368,
    r: 9.5
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1214,
    cy: 427,
    r: 9.5
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1138,
    cy: 105,
    r: 9.5
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1082,
    cy: 158,
    r: 9.5
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1356,
    cy: 79,
    r: 9.5
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1263,
    cy: 146,
    r: 9.5
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1296,
    cy: 146,
    r: 9.5
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1324,
    cy: 233,
    r: 9.5
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1296,
    cy: 283,
    r: 9.5
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1296,
    cy: 370,
    r: 9.5
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1366,
    cy: 368,
    r: 9.5
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1350,
    cy: 587,
    r: 9.5
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1296,
    cy: 496,
    r: 9.5
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1305,
    cy: 454,
    r: 9.5
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1405,
    cy: 496,
    r: 9.5
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1429,
    cy: 310,
    r: 9.5
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1570,
    cy: 346,
    r: 9.5
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1571,
    cy: 591,
    r: 9.5
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 123.5,
    cy: 635.5,
    r: 10
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 57.5,
    cy: 685.5,
    r: 10
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 92.5,
    cy: 679.5,
    r: 10
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 75.5,
    cy: 526.5,
    r: 10
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 99.5,
    cy: 482.5,
    r: 10
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 11.5,
    cy: 435.5,
    r: 10
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 40.5,
    cy: 201.5,
    r: 10
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 158.5,
    cy: 95.5,
    r: 10
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 212.5,
    cy: 213.5,
    r: 10
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 244.5,
    cy: 448.5,
    r: 10
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 264.5,
    cy: 394.5,
    r: 10
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 279.5,
    cy: 336.5,
    r: 10
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 290.5,
    cy: 298.5,
    r: 10
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 392.5,
    cy: 213.5,
    r: 10
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 590.5,
    cy: 153.5,
    r: 10
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 423.5,
    cy: 354.5,
    r: 10
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 537.5,
    cy: 695.5,
    r: 10
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1086.5,
    cy: 649.5,
    r: 10
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1093.5,
    cy: 590.5,
    r: 10
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1038.5,
    cy: 634.5,
    r: 10
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 969.5,
    cy: 634.5,
    r: 10
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 480.5,
    cy: 84.5,
    r: 10
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 604.5,
    cy: 35.5,
    r: 10
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 662.5,
    cy: 57.5,
    r: 10
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 690.5,
    cy: 80.5,
    r: 10
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 727.5,
    cy: 123.5,
    r: 10
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 646.5,
    cy: 241.5,
    r: 10
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 819.5,
    cy: 153.5,
    r: 10
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 816.5,
    cy: 203.5,
    r: 10
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 953.5,
    cy: 562.5,
    r: 10
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 534.5,
    cy: 618.5,
    r: 10
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 611.5,
    cy: 620.5,
    r: 10
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 868.3,
    cy: 138.3,
    r: 10
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1054.5,
    cy: 98.5,
    r: 10
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 947.5,
    cy: 11.5,
    r: 10
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1015.5,
    cy: 30.5,
    r: 10
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1272.5,
    cy: 626.5,
    r: 10
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 471.5,
    cy: 414.5,
    r: 10
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1249.5,
    cy: 423.5,
    r: 10
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1230.5,
    cy: 288.5,
    r: 10
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1172.5,
    cy: 146.5,
    r: 10
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1174.5,
    cy: 186.5,
    r: 10
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1318.5,
    cy: 179.5,
    r: 10
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1497.5,
    cy: 171.5,
    r: 10
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1433.5,
    cy: 79.5,
    r: 10
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1495.5,
    cy: 132.5,
    r: 10
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1490.5,
    cy: 249.5,
    r: 10
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1423.5,
    cy: 271.5,
    r: 10
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1600.5,
    cy: 335.5,
    r: 10
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1552.5,
    cy: 385.5,
    r: 10
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1515.5,
    cy: 465.5,
    r: 10
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1570.5,
    cy: 420.5,
    r: 10
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1528.5,
    cy: 520.5,
    r: 10
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1272.5,
    cy: 537.5,
    r: 10
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 392.5,
    cy: 288.5,
    r: 10
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 206.5,
    cy: 368.5,
    r: 10
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 163,
    cy: 355,
    r: 9.5
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 948.3,
    cy: 108.4,
    r: 10
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1461.5,
    cy: 322.5,
    r: 10
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1418.5,
    cy: 412.5,
    r: 10
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 807,
    cy: 248,
    r: 9.5
  })), _polyline55 || (_polyline55 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "362.5 674.5 237.3 674.5 213.5 650.5"
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 363,
    cy: 674,
    r: 9.5
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 207.5,
    cy: 642.5,
    r: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.9010aa583715a9d432709fb78e2fd671.svg";
export { ForwardRef as ReactComponent };